export default "__VITE_ASSET__7ee3d7d1__"